import React from "react";

const MiddleLayout = ({ children } : { children: any}) => {  
  return (
    <div
      className="flex-col md:flex-row justify-between flex gap-4 bg-no-repeat bg-contain md:bg-cover items-start bg-gray-100 h-screen"
    >
      <div className="mx-auto my-auto">
        {children}
      </div>
    </div>
  );
}

export default MiddleLayout